// extracted by mini-css-extract-plugin
export default {"badge":"PlaceholderText_badge__YV0Ky","badgeGray":"PlaceholderText_badgeGray__4LMyq","badgePurple":"PlaceholderText_badgePurple__r29wD"};